import axios from "axios";

const API_URL = process.env.NEXT_PUBLIC_API_URL as string;

export const rolesAll = async () => {
  try {
    const response = await axios.get(`${API_URL}/roles/all`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener los roles:", error);
    throw error;
  }
};
